// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.progression-select[data-v-61ec2971] .container:not(:last-child){margin-bottom:2rem}.progression-select[data-v-61ec2971] .red-text{color:var(--primary)}.inactive[data-v-61ec2971]{opacity:.5;pointer-events:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
